import { render, staticRenderFns } from "./BottomBtnGroup.vue?vue&type=template&id=084f87cd&scoped=true"
import script from "./BottomBtnGroup.vue?vue&type=script&lang=ts"
export * from "./BottomBtnGroup.vue?vue&type=script&lang=ts"
import style0 from "./BottomBtnGroup.vue?vue&type=style&index=0&id=084f87cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084f87cd",
  null
  
)

export default component.exports